import React from 'react'

import Tooltip from 'Pods/Shared/Tooltip'
import Icon from 'Pods/Shared/Icon/Icon'

function ProductPriceOfferButton() {
  return (
    <Tooltip
      id="productPriceOfferButton"
      className="js-auth-control js-modal product-pricing__make-offer js-offer-price"
      tooltipClassName="u-text-center"
      content="Send your price offer to the author if you want to buy it at lower price."
      href="#modal-price-offer"
    >
      <button type="button" className="btn btn-outline-default">
        <Icon type={['far', 'handshake']} notSpaced /> Offer price
      </button>
    </Tooltip>
  )
}

export default ProductPriceOfferButton
